import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hint_left hint_mini_top" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "hint_left hint_mini_top" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Просмотр загруженного файла", -1)
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_modal_image = _resolveComponent("v-modal-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.react.main_title) + " ", 1),
      _createElementVNode("span", {
        class: "modal_span",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalFile = true))
      }, " (показать пример) "),
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          (_ctx.showModalFile)
            ? (_openBlock(), _createBlock(_component_v_modal_image, {
                key: 0,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalFile = false))
              }, {
                header: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.react.sample_title), 1)
                ]),
                body: _withCtx(() => [
                  _createElementVNode("img", {
                    style: {"width":"100%"},
                    src: _ctx.api_url + 'files/sample/' + _ctx.react.sample_file
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.url_file == '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.not_load_file_hint), 1))
        : _createCommentVNode("", true),
      (_ctx.url_file != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createTextVNode(" Имя загруженного файла - \""),
            _createElementVNode("span", {
              class: "modal_span",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalFilePreview = true))
            }, _toDisplayString(_ctx.url_file.split("/")[_ctx.url_file.split("/").length - 1]), 1),
            _createTextVNode("\" "),
            _createVNode(_Transition, { name: "modal" }, {
              default: _withCtx(() => [
                (_ctx.showModalFilePreview)
                  ? (_openBlock(), _createBlock(_component_v_modal_image, {
                      key: 0,
                      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalFilePreview = false))
                    }, {
                      header: _withCtx(() => [
                        _hoisted_6
                      ]),
                      body: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: _ctx.api_url + 'files/' + _ctx.url_file
                        }, null, 8, _hoisted_7)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("input", {
      ref: "upload_file",
      type: "file",
      hidden: "",
      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitFile(_ctx.react.file_name)))
    }, null, 544),
    _createElementVNode("button", {
      type: "button",
      class: "blue_btn",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.upload_file.click())),
      style: {"float":"left","margin-left":"10px"}
    }, _toDisplayString(_ctx.react.button_title), 1)
  ], 64))
}